import request from '@/util/request';
// 详情
export const getContracInvoiceRecordList = (params, options) =>
    request.get('/api/v4ward/contract/invoice/selectInvoiceRecord', Object.assign({}, options, { params }));

//新增

export const addContractInvoiceRecord = (params, options) =>
request.post('/api/v4ward/contract/invoice/save', params, options)

//修改

export const editContractInvoiceRecord = (params, options) =>
request.post('/api/v4ward/contract/invoice/update', params, options)

//删除
export const delContracInvoiceRecord = (id) =>
    request.post('/api/v4ward/contract/invoice/remove?ids='+id);

//详情（回显）
export const getContracInvoiceRecordDetail = (id) =>
request.get('/api/v4ward/contract/invoice/detail?id='+id);

